// removed by extract-text-webpack-plugin
module.exports = {"backer":"backer___1dcL-","frame":"frame___20Vfp","bottomOptions":"bottomOptions___3n4KJ","btn":"btn___3bQbU","header":"header___1uDVu","h3":"h3___1WNzX","h4":"h4___25YMC","edit":"edit___2JTSL","h1":"h1___3IKw4","close":"close____nr7H","content":"content___1zjFJ","capitalize":"capitalize___1LQkK","dt":"dt___3vAU9","inlineDD":"inlineDD___1XGMP","dd":"dd___RtRx1","input":"input___3JRo2","btns":"btns___2WdRj","save":"save___2fbPu","cancel":"cancel___2DHw8","delete":"delete___2AC6V","editWrapper":"editWrapper___2JZY-"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/styles.scss
// module id = 400
// module chunks = 0